import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "hidden py-4 md:flex" }
const _hoisted_2 = {
  key: 0,
  class: "flex w-fit"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "flex w-fit"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "py-6 border-b border-gray-300" })
], -1)
const _hoisted_7 = { class: "block py-4 md:hidden" }
const _hoisted_8 = {
  key: 0,
  class: "flex w-fit"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 1,
  class: "flex w-fit"
}
const _hoisted_11 = ["value"]

import { PropType } from "vue";
import { storeToRefs } from "pinia";

import { useUserStore } from "@/store";
import { useRoute } from "vue-router";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabGroup',
  props: {
  selectedTab: {
    type: String,
    required: true,
  },
  tabs: {
    type: Array as PropType<{ id: string; name: string; roles?: string[] }[]>,
    required: true,
  },
  hasRoleGuard: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["select"],
  setup(__props, { emit: emits }) {

const { user } = storeToRefs(useUserStore());




const route = useRoute();

function changeTab(tab: string) {
  router.push({ name: route.name?.toString(), query: { ...route.query, tab } });
  emits("select", tab);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.hasRoleGuard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs.filter(i => i.roles!.some(propRole => _unref(user).roles.some(userRole => userRole.name === propRole))), (tab, index) => {
              return (_openBlock(), _createElementBlock("button", {
                type: "button",
                key: index,
                id: "summary",
                class: _normalizeClass([
          __props.selectedTab === tab.id ? 'border-x  border-t rounded border-gray-300 text-gray-700 border-b border-b-white' : 'text-blue border-b border-b-gray-300',
          'px-4 py-2 whitespace-nowrap capitalize',
        ]),
                onClick: ($event: any) => (changeTab(tab.id))
              }, _toDisplayString(_ctx.$t(`${tab.name}`)), 11, _hoisted_3))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
              return (_openBlock(), _createElementBlock("button", {
                type: "button",
                key: index,
                id: "summary",
                class: _normalizeClass([
          __props.selectedTab === tab.id ? 'border-x  border-t rounded border-gray-300 text-gray-700 border-b border-b-white' : 'text-blue border-b border-b-gray-300',
          'px-4 py-2 whitespace-nowrap capitalize',
        ]),
                onClick: ($event: any) => (changeTab(tab.id))
              }, _toDisplayString(_ctx.$t(`${tab.name}`)), 11, _hoisted_5))
            }), 128))
          ])),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      (__props.hasRoleGuard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("select", {
              class: "w-full",
              onChange: _cache[0] || (_cache[0] = $event => changeTab($event.target!.value))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs.filter(i => i.roles!.some(propRole => _unref(user).roles.some(userRole => userRole.name === propRole))), (tab, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: tab.id,
                  key: index
                }, _toDisplayString(_ctx.$t(`${tab.name}`)), 9, _hoisted_9))
              }), 128))
            ], 32)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("select", {
              class: "w-full",
              onChange: _cache[1] || (_cache[1] = $event => changeTab($event.target!.value))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: tab.id,
                  key: index
                }, _toDisplayString(_ctx.$t(`${tab.name}`)), 9, _hoisted_11))
              }), 128))
            ], 32)
          ]))
    ])
  ], 64))
}
}

})